<template>
  <div class="gs-mux-connect" data-mux-connect>
    <div class="gs-mux-connect__head">
      <span class="gs-mux-connect__mark" aria-hidden="true"><gs-icon name="link" size="18" /></span>
      <h3 class="gs-mux-connect__title">Connect your Mux account</h3>
    </div>
    <p class="gs-mux-connect__copy">
      <!-- One sentence per line: the test compiler keeps newlines inside text. -->
      GrooveVideo uploads and plays these videos through the Mux account you connect in VideoPlayer.gg, using the same sign-in you use here.
      Your videos stay in your own Mux account.
      Mux's free tier covers roughly 100,000 minutes of viewing per month.
    </p>
    <p v-if="status && status.last_error" class="gs-mux-connect__notice" role="alert">{{ status.last_error }}</p>
    <p v-if="error" class="gs-mux-connect__notice" role="alert">{{ error }}</p>
    <p v-if="checking && !status" class="gs-mux-connect__hint" role="status">Checking your Mux connection…</p>
    <div class="gs-mux-connect__actions">
      <gs-button variant="primary" data-action="connect-mux" :disabled="checking || !canConnect" @click="$emit('connect')">
        <gs-icon name="external-link" size="15" />
        Connect Mux
      </gs-button>
      <gs-button variant="outline" data-action="check-mux" :disabled="checking" @click="$emit('check')">
        {{ checking ? 'Checking…' : 'Check again' }}
      </gs-button>
    </div>
    <p class="gs-mux-connect__hint">
      A VideoPlayer.gg window opens. When you finish there, this updates on its own. If it doesn't, choose Check again.
    </p>
  </div>
</template>

<script>
export default {
  name: 'MuxConnectCallout',
  props: {
    status: { type: Object, default: null },
    checking: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },
  computed: {
    canConnect() {
      return Boolean(this.status && this.status.connect_url);
    },
  },
};
</script>

<style scoped>
.gs-mux-connect {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px 28px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
}

.gs-mux-connect__head {
  display: flex;
  gap: 10px;
  align-items: center;
}

.gs-mux-connect__mark {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: var(--gs-muted-foreground);
  background: var(--gs-muted);
  border-radius: 999px;
}

.gs-mux-connect__title {
  margin: 0;
  color: var(--gs-foreground);
  font-size: 16px;
  font-weight: 600;
}

.gs-mux-connect__copy,
.gs-mux-connect__hint {
  margin: 0;
  color: var(--gs-muted-foreground);
  font-size: 13px;
  line-height: 1.55;
}

.gs-mux-connect__notice {
  margin: 0;
  padding: 10px 12px;
  color: var(--gs-foreground);
  background: var(--gs-surface-subtle);
  border-left: 3px solid var(--gs-warning);
  border-radius: var(--gs-radius-sm);
  font-size: 13px;
  line-height: 1.5;
}

.gs-mux-connect__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

@media (max-width: 480px) {
  .gs-mux-connect {
    padding: 20px 16px;
  }

  .gs-mux-connect__actions .gs-button {
    flex: 1 1 100%;
  }
}
</style>
